import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DateTimeIcon from '../../../../../icons/date-time.svg';
import LocationIcon from '../../../../../icons/location.svg';
import { NormalText } from '../../../StyledComponents';
import { formatDateTime } from '../../../../helpers/dateTimeHelpers';
import ParsedMessage from './ParsedMessage';

import './MessagesList.module.scss';

class MessagesList extends React.PureComponent {
  render() {
    const {
      data,
      fullDate,
      isMobile,
      designSettings: {
        carrierMessagesHeadingsColor: headingsColor,
        carrierMessagesTextColor: textColor,
        bodyFontSize,
        bodyFont,
        bodyTextLinksColor,
        bodyTextLinksHoverColor,
      },
      locale,
    } = this.props;

    const textProps = {
      type: 'bodyPrimary',
      isMobile,
      fontSize: bodyFontSize,
      font: bodyFont,
    };

    return (
      <div styleName={classNames('list', { mobile: isMobile })}>
        {data.map(({messageDate, message, location, status}, index) => (
          <div key={index} styleName="item">
            <div styleName="date-location">
              <DateTimeIcon styleName="date-icon" style={ { fill: headingsColor } } />
              <NormalText {...textProps} color={headingsColor}>
                { formatDateTime(locale, new Date(messageDate), fullDate) }
              </NormalText>
              { location && <LocationIcon styleName="location-icon" style={ { fill: headingsColor } } /> }
              <NormalText {...textProps} color={headingsColor}>
                { location }
              </NormalText>
            </div>
            <div styleName="message">
              <NormalText {...textProps} color={textColor}>
                <ParsedMessage
                  linkStyles={ {color: bodyTextLinksColor, hoverColor: bodyTextLinksHoverColor} }
                >
                  {message}
                </ParsedMessage>
              </NormalText>
            </div>
          </div>))
        }
      </div>
    );
  }
}

MessagesList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  fullDate: PropTypes.bool,
  designSettings: PropTypes.shape({
    headingFont: PropTypes.string,
    headingFontSize: PropTypes.string,
    bodyFont: PropTypes.string,
    bodyFontSize: PropTypes.string,
    carrierMessagesHeadingsColor: PropTypes.string,
    carrierMessagesTextColor: PropTypes.string,
  }),
  locale: PropTypes.string,
};

export default MessagesList;


// WEBPACK FOOTER //
// ./src/js/widgets/Status/CarrierMessages/MessagesList/MessagesList.js